/**
 * Share permissions (item 410): what a person may do on a camera, read from what the server computed.
 * The server stays the gate; these only decide what the screens show. The key lists mirror
 * detercam/detercam_api/services/share_permissions.py and must change together with it.
 */
import type { Camera } from '@/types'

/** HTTP camera settings keys inside desired_extra_settings that only the owner or a superuser may change. */
export const HTTP_PLUMBING_KEYS: readonly string[] = [
  'send_mode', 'sms_control', 'auto_sim', 'lock_net', 'heartbeat', 'uk_lock_menu', 'sms_time_delay',
]

/** G100 settings keys that only the owner or a superuser may change (a tick does not unlock them). */
export const G100_OWNER_KEYS: ReadonlySet<string> = new Set([
  'workMode', 'timerReportValue', 'keepAliveTime', 'debugSwitch', 'qlogSwitch', 'liveRes', 'aiSwitch', 'aiDetectionZone',
])

/** Owner or superuser: everything the camera's own screens offer. */
export function hasFullRights(camera: Pick<Camera, 'is_owner'>, isSuperuser: boolean | undefined): boolean {
  return !!isSuperuser || camera.is_owner === true
}

/** May change the camera's settings: full rights, or the "can change settings" tick. */
export function canChangeCameraSettings(camera: Pick<Camera, 'is_owner' | 'my_rights'>, isSuperuser: boolean | undefined): boolean {
  return hasFullRights(camera, isSuperuser) || camera.my_rights?.change_settings === true
}
